// src/components/autopilot/SearchQueryCard.js
import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  LinearProgress
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

function SearchQueryCard({ query, index, status = 'pending', resultCount = 0 }) {
  const getStatusColor = () => {
    switch (status) {
      case 'completed':
        return '#1BE885';
      case 'running':
        return '#3b82f6';
      case 'pending':
        return '#e0e0e0';
      default:
        return '#e0e0e0';
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'completed':
        return <CheckCircleIcon sx={{ color: '#1BE885' }} />;
      case 'running':
        return <HourglassEmptyIcon sx={{ color: '#3b82f6' }} />;
      default:
        return null;
    }
  };

  return (
    <Card
      sx={{
        mb: 2,
        boxShadow: 2,
        borderLeft: `4px solid ${getStatusColor()}`,
        opacity: status === 'pending' ? 0.7 : 1
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Query {index + 1}
            </Typography>
            {getStatusIcon()}
          </Box>
          {status === 'completed' && (
            <Chip
              label={`${resultCount} results`}
              size="small"
              sx={{ bgcolor: '#1BE885', color: '#fff' }}
            />
          )}
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
            <strong>Weightage:</strong> {query.weightage || 'N/A'}
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {query.title && (
              <Chip label={`Title: ${query.title}`} size="small" variant="outlined" />
            )}
            {query.experience && (
              <Chip label={`Experience: ${query.experience}`} size="small" variant="outlined" />
            )}
            {query.skill && (
              <Chip label={`Skill: ${query.skill}`} size="small" variant="outlined" />
            )}
            {query.keyword && (
              <Chip label={`Keyword: ${query.keyword}`} size="small" variant="outlined" />
            )}
            {query.company && (
              <Chip label={`Company: ${query.company}`} size="small" variant="outlined" />
            )}
          </Box>
        </Box>

        {status === 'running' && (
          <LinearProgress sx={{ height: 6, borderRadius: 3 }} />
        )}
      </CardContent>
    </Card>
  );
}

export default SearchQueryCard;
